import angular from "angular";

// Calls the given expression when a file input's selection changes, with the chosen
// files available as `files` and the input element as `input`:
//   on-file-change="ctrl.onFileChange(files, input)"
// Add `reset-on-click` to clear the input just before the file picker opens, so choosing the
// same file again fires the change event while the chosen file name stays displayed after a load.
angular
    .module('ui-common')
    .directive('onFileChange', OnFileChangeDirective);

function OnFileChangeDirective() {
    var directive = {
        restrict: 'A',
        scope: {
            onFileChange: '&'
        },
        link: link
    };
    return directive;

    function link(scope, element, attrs) {
        if ('resetOnClick' in attrs) {
            element.on('click', function () {
                element[0].value = '';
            });
        }
        element.on('change', function () {
            scope.onFileChange({ files: element[0].files, input: element[0] });
        });
    }
}
